import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const beneficiosUnipAtivoGuard: CanMatchFn = () =>
  environment.beneficios_unip || inject(Router).createUrlTree(['/sistemas']);
